import React from 'react'
import './progressBar.css'

export default function index({percentagem}) {
  return (
    <progress className="ms-2" value={percentagem} max="100">
        {/* <span>20</span>% */}
    </progress>  
  )
}



